import {useTranslation} from 'react-i18next';

import {Grid, Typography, useMediaQuery, useTheme} from '@mui/material';

import {DesktopDisplay} from './DesktopDisplay';
import {MobileDisplay} from './MobileDisplay';
import {useFallBackLogo} from '../../../../../../hooks/useFallBackLogo';

export interface MiniCultureType {
  name: string;
  url: string;
}
interface Props {
  companyLogo: string;
  companyCultureType: MiniCultureType;
  applicantCultureType: MiniCultureType | null;
  applicantProfileImg: string;
  culturalFitScore: string;
  isDetailedCardView?: boolean;
}
export const CultureFitHeader = ({
  culturalFitScore,
  companyCultureType,
  applicantCultureType,
  companyLogo,
  applicantProfileImg,
  isDetailedCardView,
}: Props) => {
  const companyLogoUrl = useFallBackLogo(companyLogo);
  const applicantAvatarUrl = useFallBackLogo(applicantProfileImg);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(1025));
  const {t} = useTranslation();

  return (
    <Grid paddingBottom='40px'>
      {!isDetailedCardView && (
        <Typography variant='h2' paddingBottom='16px'>
          {t('applicantDashboard.matchesView.cultureFit')}
        </Typography>
      )}
      {isMobile ? (
        <MobileDisplay
          culturalFitScore={culturalFitScore}
          applicantCultureType={applicantCultureType}
          applicantAvatarUrl={applicantAvatarUrl}
          companyCultureType={companyCultureType}
          companyLogoUrl={companyLogoUrl}
        />
      ) : (
        <DesktopDisplay
          culturalFitScore={culturalFitScore}
          applicantCultureType={applicantCultureType}
          applicantAvatarUrl={applicantAvatarUrl}
          companyCultureType={companyCultureType}
          companyLogoUrl={companyLogoUrl}
        />
      )}
    </Grid>
  );
};
